import { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Progress } from './ui/progress';
import { Target } from 'lucide-react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export function GoalsWidget({ language }) {
    const [goals, setGoals] = useState([]);
    const t = language === 'de';

    useEffect(() => {
        (async () => {
            try {
                const res = await axios.get(`${API}/api/goals/active`);
                setGoals(res.data?.goals || []);
            } catch(e) {}
        })();
    }, []);

    if (goals.length === 0) return null;

    return (
        <Link to="/goals">
            <Card className="border hover:border-primary/30 transition-colors" data-testid="goals-widget">
                <CardContent className="p-3">
                    <p className="text-[10px] font-semibold text-muted-foreground flex items-center gap-1 mb-2">
                        <Target className="w-3 h-3 text-primary" />
                        {t ? 'Meine Ziele' : 'My Goals'} ({goals.length})
                    </p>
                    <div className="space-y-2">
                        {goals.slice(0, 3).map((g) => (
                            <div key={g.id} className="flex items-center gap-2">
                                <div className="flex-1 min-w-0">
                                    <p className="text-xs truncate">{g.title}</p>
                                    <Progress value={g.progress} className="h-1 mt-0.5" />
                                </div>
                                <span className={`text-xs font-bold shrink-0 ${g.progress >= 100 ? 'text-green-600' : 'text-muted-foreground'}`}>
                                    {g.progress}%
                                </span>
                            </div>
                        ))}
                    </div>
                </CardContent>
            </Card>
        </Link>
    );
}
